import { Component, OnInit } from '@angular/core';
import { environment } from "../../../../environments/environment";
import { KeycloakService } from "keycloak-angular";
import { ActivatedRoute, Params, Router } from "@angular/router";
import Swal from 'sweetalert2';

const home: string = "acasa"
const contact: string = "contact"
const despre: string = "despre"

@Component({
  selector: 'app-homepage-after',
  templateUrl: './homepage_after.component.html',
  styleUrls: ['./homepage_after.component.scss']
})
export class HomepageComponentAfter implements OnInit {

  public homepageTitle: string = "Prin intermediul POSF clientul final de energie electrică/gaze naturale poate să:";
  public homepageText1: string = "Aleagă din comparator ofertele de contracte de furnizare pe care le consideră potrivite ";
  public homepageText2: string = "Transmită furnizorului toate informaţiile şi documentele necesare contractării"
  public homepageText3: string = "Schimbe furnizorul în cel mult 24 de ore de la încheierea noului contractului sau de la data dorită"
  public offerComparison: string = "Comparator oferte furnizare pentru gaze naturale şi energie electrică";
  public offerComparisonElectricity: string = "Comparator oferte furnizare pentru energie electrică";
  public offerComparisonGas: string = "Comparator oferte furnizare pentru gaze naturale";
  public page: string;
  public petitieTooltip = '<span style="color: red; font-weight: bold">Acest formular NU este destinat semnalării problemelor tehnice legate de funcționarea platformei.</span><br>'
    + '<span style="color: red; font-weight: bold">Doar probleme contractuale legate de nerespectarea legislatiei specifice de catre furnizori si/sau operatori.</span><br>'
    + '<span style="color: red; font-weight: bold">Vă mulțumim pentru înțelegere!</span>';


  constructor(private router: Router,
    private route: ActivatedRoute,
    private keycloakService: KeycloakService) {
    this.route.queryParams.subscribe((params: Params) => {
      this.page = params['pagina'] ? params['pagina'] : this.home;
    });
  }

  ngOnInit(): void {
  }

  login(): void {
    this.keycloakService.login({ redirectUri: environment.feUrl });
  }

  inregistrare(): void {
    this.router.navigate(['inregistrare']);
  }

  get home(): string {
    return home;
  }

  get contact(): string {
    return contact;
  }

  get despre(): string {
    return despre;
  }

  onPetitieClick(event: MouseEvent): void {
    event.preventDefault();
    Swal.fire({
      html: this.petitieTooltip,
      showConfirmButton: true,
      showCancelButton: true,
      confirmButtonText: 'Continua',
      cancelButtonText: 'Renunta',
      customClass: {
        popup: 'popup-z-elevate-24-blue'
      }
    }).then(result => {
      if (result.value) {
        window.open('https://spv.anre.ro/depune-petitie/', '_blank');
      }
    });
  }

}
